var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7126 9.51115C31.9449 23.2322 28.6949 32.8388 27.9934 38.77C34.8134 36.8895 45.1276 32.4984 45.2531 23.058C45.4284 8.92064 52.0144 2.30632 52.0144 2.30632C12.1109 4.95291 22.0588 40.0233 22.0588 40.0233C22.0588 40.0233 22.1666 40.2668 23.0063 40.1146C26.9824 20.4274 42.1976 9.84524 42.7126 9.51115Z",
    fill: "#5DD641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0995 15.0461C10.0995 15.0461 17.8955 26.068 16.7145 42.9261C11.5256 39.8723 1.17554 32.6449 4.02081 24.594C7.77019 13.9608 1.55237 8.45039 1.55237 8.45039C1.55237 8.45039 14.5078 6.63787 21.8914 19.3821C26.7839 27.8371 24.1425 36.112 21.7885 40.7267C20.9041 32.5517 18.2324 19.786 10.0995 15.0461Z",
    fill: "#5DD641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.3b9dd9b40c4453806b1c64c0f96b9f4c.svg";
export { ForwardRef as ReactComponent };